import React, { useEffect, useState, useContext } from 'react'
import InvoiceStep from '../../InvoiceStep'
import PropTypes from 'prop-types'
import { CampaignContext } from '../../../contexts/CampaignContext'
import { useStepWizardAutoScrollUp } from '../../../hooks/useStepWizardAutoScrollUp'

/**
 * @param {object} props
 */
const Payment = (props) => {
    const campaignInvoiceSavedData = props.passData.campaign_invoice
    const [confirm, setConfirm] = useState(campaignInvoiceSavedData || false)

    const {
        campaignPayment,
        fetchCampaignPaymentDetails,
        paymentInfoFetched,
        fetchEnrollmentPaymentError
    } = useContext(CampaignContext)

    useStepWizardAutoScrollUp(paymentInfoFetched === true)

    useEffect(() => {
        props.update({ disableNextButton: () => !confirm })
    }, [confirm])

    useEffect(() => {
        if (props.saveId) props.update({ completed: true, gotoNext: true, saveData: confirm })
    }, [props.saveId])

    useEffect(() => {
        if (campaignPayment === null) {
            fetchCampaignPaymentDetails()
        }
    }, [])

    return <InvoiceStep
        update={props.update}
        passData={props.passData}
        showConfirmation={props.showConfirmation}
        confirm={confirm}
        onChangeHandler={setConfirm}
        showAlert={props.showAlert}
        alertID='sms_enrollment_campaign_enrollment_info'
        price={15.00}
        tax={2.25}
        payment={campaignPayment}
        paymentInfoFetched={paymentInfoFetched}
        fetchEnrollmentPaymentError={fetchEnrollmentPaymentError}
        onClickRetry={fetchCampaignPaymentDetails}
        onCancel={props.onCancel}
    />
}

Payment.propTypes = {
    passData: PropTypes.object,
    update: PropTypes.func,
    saveId: PropTypes.number,
    showConfirmation: PropTypes.bool,
    showAlert: PropTypes.bool,
    onCancel: PropTypes.function
}

export default Payment
